<template>
<div class="chapter">
<div class="inner_page">
<div id="Copyright" style="font-size:75%;">
<p class="space"> </p>
<p class="copy">First published in Great Britain in 2016 by<br/>Pen &amp; Sword Transport<br/>an imprint of<br/>Pen &amp; Sword Books Ltd<br/>47 Church Street<br/>Barnsley<br/>South Yorkshire<br/>S70 2AS</p>
<p class="copy1">Copyright © Mark Smithers 2016</p>
<p class="copy1">ISBN: 978 1 47384 400 1<br/>
PDF ISBN: 978 1 47384 403 2<br/>
EPUB ISBN: 978 1 47384 401 8<br/>
PRC ISBN: 978 1 47384 402 5</p>
<p class="copy1">The right of Mark Smithers to be identified as the Author of this Work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy1">A CIP catalogue record for this book is available from the British Library</p>
<p class="copy1">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.</p>
<p class="copy1">Typeset in Ehrhardt by<br/>Mac Style Ltd, Bridlington, East Yorkshire<br/>Printed and bound by Replika Press Pvt. Ltd.</p>
<p class="copy1">Pen &amp; Sword Books Ltd incorporates the imprints of Pen &amp; Sword Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Transport, True Crime, and Fiction, Frontline Books, Leo Cooper, Praetorian Press, Seaforth Publishing and Wharncliffe.</p>
<p class="copy1">For a complete list of Pen &amp; Sword titles please contact<br/>PEN &amp; SWORD BOOKS LIMITED<br/>47 Church Street, Barnsley, South Yorkshire S70 2AS, England<br/>E-mail: <a href="mailto:enquiries@pen-and-sword.co.uk">enquiries@pen-and-sword.co.uk</a><br/>Website: <a href="http://www.pen-and-sword.co.uk" target="_blank">www.pen-and-sword.co.uk</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?761ff0b1